import React, { useState } from "react";
import ReactSelect from "react-select";
import { useFormContext, useController } from "react-hook-form";
import { InputLabel } from "../InputLabel/InputLabel";
import { selectBaseClassNames } from "../PaziaSelect/styles";
import { InputErrorMessage } from "../InputErrorMessage/InputErrorMessage";
import { IDropdownOption } from "../PaziaSelect/PaziaSelect";

export interface PaziaMultiSelectProps {
  name: string;
  options: IDropdownOption[];
  onChange?: (event: any) => void;
  value?: any;
  required?: boolean;
  label?: string;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  key?: React.Key;
  hideErrors?: boolean;
  defaultValue?: IDropdownOption[] | string[] | number[];
  placeholder?: string;
}

export const MultiSelect = ({
  label,
  name,
  value,
  onChange,
  isLoading,
  className,
  disabled,
  key,
  defaultValue,
  options,
  required,
  placeholder,
}: PaziaMultiSelectProps): JSX.Element => {
  const [defValue] = useState(() => {
    const defaultArray = Array.isArray(defaultValue)
      ? defaultValue
      : (defaultValue + "").includes(",")
        ? (defaultValue + "").split(",")
        : [defaultValue];

    return defaultArray.map((x) => {
      return typeof x == "object" ? x : options.find((y) => y.value == x);
    });
  });

  return (
    <div className={`flex ${label ? "flex-col" : ""} ${className ?? ""}`}>
      <InputLabel label={label} required={required} name={name} />
      <ReactSelect
        isSearchable={true}
        key={key}
        // controlShouldRenderValue={false}
        // hideSelectedOptions={false}
        onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
          e.key === "Enter" && e.preventDefault()
        }
        isMulti
        inputId={name}
        isDisabled={disabled}
        styles={{
          control: (provided) => ({
            ...provided,
            boxShadow: "none",
            color: disabled ? "#6B7280" : provided.color,
            backgroundColor: disabled ? "red" : provided.backgroundColor,
          }),
          container: (provided) => ({
            ...provided,
            width: "100%",
          }),
          // gray out when disabled
          singleValue: (provided) => ({
            ...provided,
          }),
        }}
        onChange={onChange}
        value={value}
        classNames={selectBaseClassNames(disabled)}
        name={name}
        isLoading={isLoading}
        placeholder={placeholder || "Wybierz..."}
        defaultValue={defValue}
        noOptionsMessage={() => "Brak wyników"}
        options={options}
      />
    </div>
  );
};

export const PaziaMultiSelect = ({
  label,
  name,
  required,
  className,
  options,
  disabled,
  hideErrors,
  onChange,
  placeholder,
  isLoading,
}: PaziaMultiSelectProps): JSX.Element => {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
  });

  const onChangeHandler = (ids: string[]) => {
    field.onChange(ids);
    if (onChange) onChange(ids);
  };

  // Calculate the selected values
  const selectedValues = React.useMemo(() => {
    const fieldValues = field.value ?? [];
    // Use loose equality to handle number/string mismatches
    return options.filter((c) =>
      fieldValues.some((val: any) => val == c.value)
    );
  }, [field.value, options]);

  return (
    <div className={className ?? ""}>
      <MultiSelect
        value={selectedValues}
        // @ts-ignore
        onChange={(val) => onChangeHandler(val.map((x) => x.value))}
        label={label}
        options={options}
        disabled={disabled}
        required={required}
        defaultValue={field.value}
        placeholder={placeholder}
        name={field.name}
        isLoading={isLoading}
      />
      {!hideErrors && <InputErrorMessage name={name} />}
    </div>
  );
};
